import { confirmation } from '@/utils/alert'

const prepareShow = specializations => {
  return specializations
}

export default {
  doDelete (item, msg) {
    this.currentEntity = item
    const message = {
      label: 'Excluir',
      title: 'Atenção',
      message: msg,
      cancel: 'Cancelar'
    }

    confirmation(confirm => {
      if (!confirm) {
        return
      }

      this.doDeleteWithoutConfirmation(item)
    }, message.message, message.title, message.label, message.cancel)
  },
  doDeleteWithoutConfirmation (entity) {
    this.currentEntity = entity
    if (!this.beforeDelete(entity)) {

    }
    this.$http.delete('v1/professional/documents/' + entity.id)
      .then(({data}) => {
        this.afterDelete(entity, data)
      })
  },
  prepareShow
}



// WEBPACK FOOTER //
// ./src/app/professional/documents/resources/methods.js